import 'zone.js';
import { createApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { createCustomElement } from '@angular/elements';
import { NavigationComponent } from './app/navigation/navigation.component';

createApplication(appConfig)
  .then((appRef) => {
    const injector = appRef.injector;
    const element = createCustomElement(NavigationComponent, { injector });
    if (!customElements.get('app-navigation')) {
      customElements.define('app-navigation', element);
    }
  })
  .catch((err) => console.error(err));
